package feature.businessType.handler

import feature.businessType.model.BusinessType
import feature.businessType.repository.BusinessTypeRepository
import feature.businessType.viewModel.BusinessTypeViewModel


class BusinessTypeHandler {

    private lateinit var businessTypeViewModel: BusinessTypeViewModel
    val repository = BusinessTypeRepository()
    var allBusinessType: ArrayList<BusinessType> = arrayListOf()

    init {
        instance = this
    }

    companion object {
        private var instance: BusinessTypeHandler? = null
        fun shared(): BusinessTypeHandler {
            if (instance != null) {
                return instance as BusinessTypeHandler
            } else {
                return BusinessTypeHandler()
            }
        }
    }
}